'use client';
import dynamic from 'next/dynamic';

const HistoryPage = dynamic(() => import('@/views/text/historyPage'), { ssr: false });

export default HistoryPage;
